// A fresh tab has no saved admin/user view, so useAuth defaults admins to the admin view,
// which has no customer pages. Seeding the user view for customer paths fixes that.

// Every customer page in routes/UserRoutes.tsx except the paths the admin view also serves.
// adminViewDefault.test.ts fails if a page is added there and not here.
const CUSTOMER_PAGE_PATHS = [
    "/help",
    "/listings",
    "/create-listing",
    "/listing",
    "/create-campaign",
    "/edit-campaign",
    "/promotions",
    "/my-content",
    "/analytics",
    "/my-niche",
    "/add-post",
    "/settings",
    "/connections",
    "/post",
];

export const isCustomerPagePath = (pathname: string): boolean => {
    // The router matches paths without regard to case, so this must too.
    const lowered = pathname.toLowerCase();
    return CUSTOMER_PAGE_PATHS.some((page) => lowered === page || lowered.startsWith(`${page}/`));
};

export const seedAdminViewForFreshTab = (
    pathname: string,
    storage: Storage = window.sessionStorage,
): void => {
    try {
        if (storage.getItem("isAdminView") === null && isCustomerPagePath(pathname)) {
            storage.setItem("isAdminView", "false");
        }
    } catch {
        // Storage blocked (private mode, policy): keep today's default rather than break start-up.
    }
};
